/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import CaretUpIcon from '@offerzen/zenicon/CaretUpIcon'
import CaretDownIcon from '@offerzen/zenicon/CaretDownIcon'
import AccessibleIcon from '../../../elements/AccessibleIcon'
import { specialKeyPressed } from '../../../helpers/eventHelpers'
import { colors } from '../../../themes'

import Title from './Title'
import styles from './styles'

export const Collapsible = ({
  children,
  isCollapsible = true,
  title,
  subtitle,
  icon,
  iconColor,
  open,
  onToggle,
  className,
  bodyClassName,
}) => {
  const [isOpen, setIsOpen] = React.useState(open)

  useEffect(() => {
    if (open !== isOpen) {
      setIsOpen(open)
    }
  }, [open])

  const toggleCollapsible = () => {
    const newIsOpen = !isOpen
    setIsOpen(newIsOpen)

    if (onToggle) {
      onToggle(newIsOpen)
    }
  }

  return isCollapsible ? (
    <div className={cx(styles.wrapper, className)}>
      <a
        className={styles.toggle}
        tabIndex="0"
        onClick={toggleCollapsible}
        onKeyDown={ev => {
          if (ev.key === 'Enter' && !specialKeyPressed(ev)) {
            toggleCollapsible()
          }
        }}>
        <Title title={title} subtitle={subtitle} icon={icon} iconColor={iconColor} />
        <div className={styles.caret}>
          <AccessibleIcon icon={isOpen ? CaretUpIcon : CaretDownIcon} size={16} color={colors.grayChateau} />
        </div>
      </a>

      {Boolean(isOpen) && <div className={cx(styles.body, bodyClassName)}>{children}</div>}
    </div>
  ) : (
    <Title title={title} subtitle={subtitle} icon={icon} iconColor={iconColor} className={cx(className)} />
  )
}

const { string, func, bool, oneOfType, node, arrayOf } = PropTypes
Collapsible.propTypes = {
  title: string.isRequired,
  subtitle: string,
  onToggle: func,
  open: bool,
  isCollapsible: bool,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  iconColor: string,
  className: string,
  bodyClassName: string,
  children: oneOfType([arrayOf(node), node]),
}
Collapsible.defaultProps = {
  open: false,
}
